import Athletica from './athletica.vue'
import BoxingDuel from './boxing-duel.vue'
import ClockControl from './clock-control.vue'
import Credits from './credits.vue'
import CustomBug from './custom-bug.vue'
import FigScoreCard from './fig-score-card.vue'
import FigScoreLowerThird from './fig-score-lower-third.vue'
import FigTeamPresentation from './fig-team-presentation.vue'
import FloorballScoreboard from './floorball-scoreboard.vue'
import FloorballScoreboardPenalty from './floorball-scoreboard-penalty.vue'
import FootballTactical from './football-tactical'
import GenericClock from './generic-clock.vue'
import GenericImage from './generic-image'
import GenericLowerThird from './generic-lower-third.vue'
import IfscVerticalLife from './ifsc-vertical-life.vue'
import LowerThirdAthlete from './lower-third-athlete.vue'
import ManagerVideo from './manager-video.vue'
import MatchTitle from './match-title.vue'
import UiaaResultsCenter from './uiaa-results-center.vue'
import UiaaVerticalLife from './uiaa-vertical-life.vue'
import UiaaLeadIntermediateChart from './uiaa-lead-intermediate-chart.vue'
import UiaaLeadIntermediateStandings from './uiaa-lead-intermediate-standings.vue'
import UiaaSpeedIntermediateStandings from './uiaa-speed-intermediate-standings.vue'
import Knockout from './knockout.vue'
import LoopicTemplate from './loopic-template.vue'
import PdfPresentation from './pdf-presentation.vue'
import PollingResults from './polling-results.vue'
import PollingResultsList from './polling-results-list.vue'
import RankingList from './ranking-list.vue'
import Sponsors from './sponsors.vue'
import SponsorsAuto from './sponsors-auto.vue'
import SstvBug from './sstv-bug.vue'
import StartingList from './starting-list.vue'
import SwissWrestlingDuel from './swiss-wrestling-duel.vue'
import SwissWrestlingDuel2024 from './swiss-wrestling-duel-2024.vue'
import SwissWrestlingDuel2026 from './swiss-wrestling-duel-2026.vue'
import SwissWrestlingMatches from './swiss-wrestling-matches.vue'
import SwissWrestlingLeaderboard from './swiss-wrestling-leaderboard.vue'
import SwissWrestlingNotenblatt from './swiss-wrestling-notenblatt.vue'
import SwissWrestlingResult from './swiss-wrestling-result.vue'
import SwissWrestlingResult2024 from './swiss-wrestling-result-2024.vue'
import SwissWrestlingSteckbrief from './swiss-wrestling-steckbrief.vue'
import TennisScoreboard from './tennis-scoreboard.vue'
import UiaaLowerThirdLead from './uiaa-lower-third-lead.vue'
import UiaaLowerThirdSpeed from './uiaa-lower-third-speed.vue'
import UiaaPartnerLogos from './uiaa-partner-logos.vue'
import UiaaVictoryCeremonyAthlete from './uiaa-victory-ceremony-athlete.vue'
import UiaaVictoryCeremonyGroup from './uiaa-victory-ceremony-group.vue'
import Volleyball from './volleyball.vue'
import VolleyballScoreboard from './volleyball-scoreboard.vue'

const Templates = {
  install (Vue) {
    Vue.component('athletica', Athletica)
    Vue.component('boxing-duel', BoxingDuel)
    Vue.component('clock-control', ClockControl)
    Vue.component('credits', Credits)
    Vue.component('custom-bug', CustomBug)
    Vue.component('fig-score-card', FigScoreCard)
    Vue.component('fig-score-lower-third', FigScoreLowerThird)
    Vue.component('fig-team-presentation', FigTeamPresentation)
    Vue.component('floorball-scoreboard', FloorballScoreboard)
    Vue.component('floorball-scoreboard-penalty', FloorballScoreboardPenalty)
    Vue.component('football-tactical', FootballTactical)
    Vue.component('generic-clock', GenericClock)
    Vue.component('generic-image', GenericImage)
    Vue.component('generic-lower-third', GenericLowerThird)
    Vue.component('ifsc-vertical-life', IfscVerticalLife)
    Vue.component('lower-third-athlete', LowerThirdAthlete)
    Vue.component('manager-video', ManagerVideo)
    Vue.component('match-title', MatchTitle)
    Vue.component('uiaa-results-center', UiaaResultsCenter)
    Vue.component('uiaa-vertical-life', UiaaVerticalLife)
    Vue.component('uiaa-lead-intermediate-chart', UiaaLeadIntermediateChart)
    Vue.component('uiaa-lead-intermediate-standings', UiaaLeadIntermediateStandings)
    Vue.component('uiaa-speed-intermediate-standings', UiaaSpeedIntermediateStandings)
    Vue.component('knockout', Knockout)
    Vue.component('loopic-template', LoopicTemplate)
    Vue.component('pdf-presentation', PdfPresentation)
    Vue.component('polling-results', PollingResults)
    Vue.component('polling-results-list', PollingResultsList)
    Vue.component('ranking-list', RankingList)
    Vue.component('sponsors', Sponsors)
    Vue.component('sponsors-auto', SponsorsAuto)
    Vue.component('sstv-bug', SstvBug)
    Vue.component('starting-list', StartingList)
    Vue.component('swiss-wrestling-duel', SwissWrestlingDuel)
    Vue.component('swiss-wrestling-duel-2024', SwissWrestlingDuel2024)
    Vue.component('swiss-wrestling-duel-2026', SwissWrestlingDuel2026)
    Vue.component('swiss-wrestling-matches', SwissWrestlingMatches)
    Vue.component('swiss-wrestling-leaderboard', SwissWrestlingLeaderboard)
    Vue.component('swiss-wrestling-notenblatt', SwissWrestlingNotenblatt)
    Vue.component('swiss-wrestling-result', SwissWrestlingResult)
    Vue.component('swiss-wrestling-result-2024', SwissWrestlingResult2024)
    Vue.component('swiss-wrestling-steckbrief', SwissWrestlingSteckbrief)
    Vue.component('tennis-scoreboard', TennisScoreboard)
    Vue.component('uiaa-lower-third-lead', UiaaLowerThirdLead)
    Vue.component('uiaa-lower-third-speed', UiaaLowerThirdSpeed)
    Vue.component('uiaa-partner-logos', UiaaPartnerLogos)
    Vue.component('uiaa-victory-ceremony-athlete', UiaaVictoryCeremonyAthlete)
    Vue.component('uiaa-victory-ceremony-group', UiaaVictoryCeremonyGroup)
    Vue.component('volleyball', Volleyball)
    Vue.component('volleyball-scoreboard', VolleyballScoreboard)
  }
}

export default Templates



// WEBPACK FOOTER //
// ./src/components/templates/index.js